(function() {
  const pills = document.querySelectorAll('.bulk-quantity-pill');
  const form = document.querySelector('form[action$="/cart/add"]');

  if (!form || !pills.length) return;

  const quantityInput = form.querySelector('input[name="quantity"]');

  const firstPillValue = pills[0].getAttribute('data-quantity-value');
  pills[0].classList.add('active');
  if (quantityInput) {
    quantityInput.value = firstPillValue;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  pills.forEach(pill => {
    pill.addEventListener('click', function() {
      const value = this.getAttribute('data-quantity-value');

      // Update the quantity input
      if (quantityInput) {
        quantityInput.value = value;
        // Trigger change event for any listeners
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update active state on pills
      pills.forEach(p => p.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Sync pills when quantity input changes manually
  if (quantityInput) {
    quantityInput.addEventListener('change', function() {
      const currentVal = this.value;
      pills.forEach(pill => {
        if (pill.getAttribute('data-quantity-value') === currentVal) {
          pill.classList.add('active');
        } else {
          pill.classList.remove('active');
        }
      });
    });
  }
})();


/* swiper.js init for UGC in testimonials.liquid */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper for UGC
  const ugcSwiper = new Swiper('.ugc-swiper', {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: true,
    centeredSlides: true,
    
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides:4,

/*     breakpoints: {
      480: {
        slidesPerView: 1.2,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup:1,
        spaceBetween: 18
      },
      1024: {
        slidesPerView: 2.66,
        slidesPerGroup:1,
        spaceBetween: 18
      }
    }, */
    // Navigation arrows
    navigation: {
      nextEl: '.ugc-swiper-button-next',
      prevEl: '.ugc-swiper-button-prev',
    }
        
  });
});